import { defineComponent as _defineComponent } from 'vue'
import { computed, ComputedRef } from 'vue';
import {
    CallModel,
    CallTranscriptModel,
    CallParticipantType,
    CallBulletType,
    CallPlayerGetters,
} from '@/types';
import { PlayIcon } from '@heroicons/vue/solid';

import store from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'CallPlayerBullets',
  props: {
    call: {
        type: Object as () => CallModel,
        required: true,
    },
    callDuration: {
        type: Number,
        required: true,
    },
    bulletType: {
        type: String as () => CallBulletType,
        required: true,
    },
    participantType: {
        type: String as () => CallParticipantType,
        required: true,
    },
},
  emits: ['playSnippet'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();



const isBulletTypeRegistered = __props.bulletType === CallBulletType.registered;
const isBulletTypeMatched = __props.bulletType === CallBulletType.matched;

const emit = __emit;

const callPlayerSearchQuery: ComputedRef<string> = computed(
    () => store.getters[CallPlayerGetters.SEARCH_QUERY],
);
const callPlayerSelectedWords: ComputedRef<string[]> = computed(() => {
    const selectedWordsMap = store.getters[CallPlayerGetters.SELECTED_WORDS];
    return Array.from(selectedWordsMap.get(__props.participantType) ?? []);
});

const bullets = computed(() => {
    if (!__props.call?.transcripts) return [];

    return __props.call.transcripts
        .filter(({ participant }) => participant === __props.participantType)
        .map((transcript) => {
            const matchedWords = transcript.words.filter((word) => {
                const query = callPlayerSearchQuery.value;
                const selectedWords = callPlayerSelectedWords.value;
                return word === query || selectedWords.includes(word);
            });

            return {
                ...transcript,
                matchedWords,
            };
        })
        .filter(({ registeredWords = [], matchedWords = [] }) => {
            return (
                (isBulletTypeRegistered && registeredWords.length > 0) ||
                (isBulletTypeMatched && matchedWords.length > 0)
            );
        });
});

function playSnippet(start: number, end: number) {
    emit('playSnippet', start, end);
}

function getBulletPosition(item: CallTranscriptModel) {
    return (item.startedAt / __props.callDuration) * 100 + '%';
}

function getWordsByBulletType(transcript: CallTranscriptModel): string[] {
    let words: string[] = [];

    if (isBulletTypeRegistered) words = transcript.registeredWords;
    else if (isBulletTypeMatched) words = transcript.matchedWords;

    const uniqueSortedWords = [...new Set(words)].sort();

    return uniqueSortedWords;
}

const variant = __props.bulletType == CallBulletType.registered ? 'blue' : 'orange';
const playColor = `text-${variant}-500`;
const bulletColor = `bg-${variant}-500/50`;

const __returned__ = { isBulletTypeRegistered, isBulletTypeMatched, emit, callPlayerSearchQuery, callPlayerSelectedWords, bullets, playSnippet, getBulletPosition, getWordsByBulletType, variant, playColor, bulletColor, get PlayIcon() { return PlayIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})